import React from 'react';
import { Link } from 'react-router-dom';
import ExpoImg from '../../assets/icon/expo.svg';
import FirebaseImg from '../../assets/icon/firebase.svg';
import MapGoogleImg from '../../assets/icon/google-maps.svg';
import ApplemapImg from '../../assets/icon/apple-map.svg';
import earthImg from '../../assets/icon/earth.svg';
import reactImg from '../../assets/icon/react.svg';
import GPTIMG from '../../assets/icon/chartGpT.svg';
import githubImg from '../../assets/icon/github.svg';
import FigmaImg from '../../assets/icon/figma.svg';
import tailwindImg from '../../assets/icon/tailwind.svg';
import photoshopImg from '../../assets/icon/photoshop.svg';
import jsImg from '../../assets/icon/js.svg';
import canvaImg from '../../assets/icon/canva.svg';
import googleAuthImg from '../../assets/icon/google-auth.svg';

const SKill = () => {

     const tools = [
          {
               name: "Expo",
               url: "https://expo.dev/",
               svg: ExpoImg
          },
          {
               name: "Firebase",
               url: "https://firebase.google.com/",
               svg: FirebaseImg
          },
         
          {
               name: "JavaScript",
               url: "https://www.javascript.com/",
               svg: jsImg
          },
          {
               name: "React",
               url: "https://react.dev/",
               svg: reactImg
          },
          {
               name: "React Native Navigation",
               url: "https://reactnavigation.org/",
               svg: earthImg
          },

          {
               name: "Google Maps",
               url: "https://maps.google.com/",
               svg: MapGoogleImg
          },
          {
               name: "Apple Maps",
               url: "https://www.apple.com/maps/",
               svg: ApplemapImg
          },

          {
               name: "React Native Skia",
               url: "https://shopify.github.io/react-native-skia/",
               svg: reactImg
          },
         
          {
               name: "GitHub",
               url: "https://github.com/",
               svg: githubImg
          },
          {
               name: "Figma",
               url: "https://www.figma.com/",
               svg: FigmaImg
          },
          {
               name: "Canva",
               url: "https://www.canva.com/",
               svg: canvaImg
          },
          
          {
               name: "Tailwind",
               url: "https://tailwindcss.com/",
               svg: tailwindImg
          },
          {
               name: "Google Auth",
               url: "https://developers.google.com/identity",
               svg: googleAuthImg
          },
          {
               name: "Photopia",
               url: "https://www.photopia.nl/",
               svg: photoshopImg
          },
          {
               name: "ChatGPT",
               url: "https://openai.com/chatgpt",
               svg: GPTIMG
          },
     ];




     return (
          <div>
               <div className='__skill'>
                    <div className='row'>
                         {tools.map((tool, index) => (
                              <div className="col-3 col-sm-2 column-sec" key={index}>
                                   <div className="card-in">
                                        <Link to={tool.url} target="_blank" rel="noopener noreferrer">
                                             <div className="Icon">
                                                  <img src={tool.svg} alt={tool.name} />
                                             </div>
                                        </Link>
                                   </div>
                              </div>
                         ))}
                    </div>
               </div>
          </div>
     );
}

export default SKill;
